import { useFetchCallType } from '@rahtab/auth/lib/token-based-auth';

export const useGetConflictReasons = () => {
  const [refetch, { called, loading, data }] = useFetchCallType('GetCorrectionReasons');
  console.log('getReasons', loading, data);
  return {
    data: getConflictResultsReducer(data),
    loading,
    called,
    refetch,
  };
};
function getConflictResultsReducer(data?: ConflictReason[]) {
  if (!data) return;
  const reasonList = data.map((item) => {
    const { ReasonCode: reasonCode, ReasonName: reasonLabel } = item;

    const reason = {
      reasonCode,
      reasonLabel,
    };
    return reason;
  });

  return reasonList;
}
interface ConflictReason {
  ReasonCode: string;
  ReasonName: string;
}
